import { analyzePages } from '@wix/ambassador-promote-accessibility-v2-rule-execution-result/http';
import { ExecutionProfile } from '@wix/ambassador-promote-accessibility-v2-rule-execution-result/types';
import { useErrorHandler, useExperiments, useHttpClient } from '@wix/fe-essentials/react';
import { assertNotOptional } from '@wix/seo-common-core';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { rescanTriggerGroupIdAtom } from '../../atoms/session-atoms';
import { AnalysisState, usePanelStateAtom } from '../../hooks/rules-state';
import { useA11yDebug } from '../../hooks/use-a11y-debug';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
export const useAnalyzePage = disableAxe => {
  const httpClient = useHttpClient();
  const {
    withErrorHandler
  } = useErrorHandler();
  const {
    a11yWizardAdapter
  } = useA11yWizardAdapter();
  const panelState = usePanelStateAtom();
  const rescanTriggerGroupId = useAtomValue(rescanTriggerGroupIdAtom);
  const a11yDebug = useA11yDebug();
  const {
    experiments
  } = useExperiments();
  const analyzePage = useCallback(async (itemType, pageId, path) => {
    panelState.setGroupData(rescanTriggerGroupId ?? pageId, {
      analysisState: AnalysisState.Analyzing
    });
    try {
      if (!experiments.enabled('specs.a11y.A11yWizardRmVersion')) {
        await a11yWizardAdapter.triggerEditorSave();
      }
      const response = await withErrorHandler(async () => httpClient.request(analyzePages({
        itemType,
        options: {
          disableAxe,
          executionProfile: ExecutionProfile.EXECUTION_PROFILE_A11Y
        },
        pagesMetadata: [{
          pageId,
          path
        }]
      })), {
        errorCodesMap: {}
      });
      a11yDebug.addAnalyzeResponse == null || a11yDebug.addAnalyzeResponse(response);
      const {
        job
      } = response.data;
      assertNotOptional(job, 'job');
      return job;
    } catch (error) {
      panelState.setGroupData(pageId, {
        analysisState: AnalysisState.AnalyzeFailed
      });
      throw error;
    }
  }, [panelState, rescanTriggerGroupId, a11yWizardAdapter, withErrorHandler, a11yDebug, httpClient, disableAxe, experiments]);
  return {
    analyzePage
  };
};
//# sourceMappingURL=use-analyze-page.js.map